<script>
	import CostBreakdownTable from "src/components/CostBreakdownTable/CostBreakdownTable.svelte";
	import CustomCollapseCard from "src/components/CustomCollapseCard/CustomCollapseCard.svelte";
	import CustomTextArea from "src/components/CustomTextArea/CustomTextArea.svelte";
	import { splitByComma } from "src/utils/misc";
	import { Col, Row } from "@sveltestrap/sveltestrap";

	export let caseDetails;
	export let damageLocations = "";
	export let form;
	export let tnsRemarks;

	let items = [];

	$: if (caseDetails.priceQuotation) {
		items = caseDetails.priceQuotation.map((item) => ({
			item: item.item,
			value: item.cost,
		}));
	}
</script>

<CustomCollapseCard isOpenDefault={true} title="Quotation" customClass="mb-4">
	<div class="p-0">
		<Row>
			<Col xs={4}>
				<div class="description">Case Type</div>
				<div class="value">{caseDetails.caseType}</div>
			</Col>
			{#if caseDetails.caseType === "Accident"}
				<Col xs={4}>
					<div class="description">Accident GIA Report No</div>
					<div class="value">
						{caseDetails.accidentGIA ||
							caseDetails.giaReportNo ||
							"-"}
					</div>
				</Col>
			{/if}
			<Col xs={4}>
				<div class="description">Type of Claim</div>
				<div class="value">{caseDetails.claimType}</div>
			</Col>
			{#if caseDetails.caseType !== "Accident"}
				<Col>
					<div class="description">Damage Location</div>
					<div class="value">
						{splitByComma(caseDetails.damageLocation)}
					</div>
				</Col>
			{/if}
		</Row>
		<hr class="divider" />
		<Row>
			{#if caseDetails.caseType === "Accident"}
				<Col>
					<div class="description">Damage Location</div>
					<div class="value">
						{splitByComma(caseDetails.damageLocation)}
					</div>
				</Col>
			{/if}
			<Col xs={4}>
				<div class="description">Liability Status</div>
				<div class="value">{caseDetails.liabilityStatus}</div>
			</Col>
			<Col xs={4}>
				<div class="description">Number of Repair Days</div>
				<div class="value">{caseDetails.repairDays}</div>
			</Col>
		</Row>
		<hr class="divider" />
		<Row>
			<Col>
				<div class="description">Actual Repair Cost</div>
				<div class="value">
					{parseFloat(caseDetails.actualCost).toFixed(2)}
				</div>
			</Col>
		</Row>
		<hr class="divider" />
		<div>Cost Breakdown</div>
		<CostBreakdownTable {items} />
		{#if caseDetails.status === "Approving"}
			<Row>
				<Col xs={12}>
					<label for="remarks" class="d-block">
						<span>
							T&S Remarks<span class="text-danger">*</span>
						</span>
					</label>
					<CustomTextArea
						bind:value={$tnsRemarks.value}
						maxlength={3000}
						placeholder="Enter remarks"
						error={$form.hasError("tnsRemarks.required")}
						errorText={"Remarks is required."}
					/>
				</Col>
			</Row>
		{:else if caseDetails.tsRemarks}
			<Row>
				<Col>
					<div class="description">T&S Remarks</div>
					<div class="value">{caseDetails.tsRemarks}</div>
				</Col>
			</Row>
		{/if}
		<hr class="divider" />
		<Row>
			<Col>
				<div class="description">FQ Remarks</div>
				<div class="value">{caseDetails.fqRemarks}</div>
			</Col>
		</Row>
	</div>
</CustomCollapseCard>
